import { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import CustomDialogTitle from "../../components/Common/customDialogTitle";
import UpiPayment from "./upiPayment";
import BankPayment from "./bankPayment";

const MakePaymentModal = ({
  purchaseData,
  paymentModal,
  setPaymentModal,
}: any) => {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const privateInstance = useAxiosInstance();

  function showPosition(position: any) {
    setLatitude(position.coords.latitude);
    setLongitude(position.coords.longitude);
  }

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <Dialog
      open={paymentModal}
      onClose={() => setPaymentModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <CustomDialogTitle
        id="customized-dialog-title"
        onClose={() => setPaymentModal(false)}
      >
        <Stack direction="row" alignItems="center">
          <Typography variant="h4" sx={{ textTransform: "capitalize" }}>
            Payout - {purchaseData?.supplier_name}
          </Typography>
        </Stack>
      </CustomDialogTitle>
      <DialogContent>
        {purchaseData?.payment_mode == "BANK" ? (
          <BankPayment
            purchaseData={purchaseData}
            lat={latitude}
            long={longitude}
            setPaymentModal={setPaymentModal}
          />
        ) : (
          <UpiPayment
            purchaseData={purchaseData}
            lat={latitude}
            long={longitude}
            setPaymentModal={setPaymentModal}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MakePaymentModal;
